var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"text-align":"right","padding":"10px"}},[_c('span',{staticStyle:{"background":"#000","padding":"10px","border":"2px solid #f3f3f3","border-radius":"14.2px","color":"#fff"},attrs:{"id":"time"},domProps:{"innerHTML":_vm._s(_vm.time)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }